export default "__VITE_ASSET__9d9e074a__"